import React from 'react'
import LowerSectionLatestProductLeft from './LowerSectionLatestProductLeft'
import LowerSectionLatestProductRight from './LowerSectionLatestProductRight'

const LowerSectionLatestProductMain = () => {
    return (
        <>
            <section className="main-wrap">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-3">
                         <LowerSectionLatestProductLeft/>
                        </div>
                        <div className="col-md-9">
                        <LowerSectionLatestProductRight/>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default LowerSectionLatestProductMain